/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stripe_Account_StatusInputs */

const en_stripe_account_status = /** @type {(inputs: Stripe_Account_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Account Status`)
};

const es_stripe_account_status = /** @type {(inputs: Stripe_Account_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado de la cuenta Stripe`)
};

const fr_stripe_account_status = /** @type {(inputs: Stripe_Account_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut du compte Stripe`)
};

const de_stripe_account_status = /** @type {(inputs: Stripe_Account_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe-Kontostatus`)
};

const ja_stripe_account_status = /** @type {(inputs: Stripe_Account_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe アカウントのステータス`)
};

const zh_stripe_account_status = /** @type {(inputs: Stripe_Account_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe 账号状态`)
};

const ar_stripe_account_status = /** @type {(inputs: Stripe_Account_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حالة حساب Stripe`)
};

const id_stripe_account_status = /** @type {(inputs: Stripe_Account_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status Akun Stripe`)
};

const it_stripe_account_status = /** @type {(inputs: Stripe_Account_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato dell'Account Stripe`)
};

const ru_stripe_account_status = /** @type {(inputs: Stripe_Account_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус аккаунта Stripe`)
};

const pt_stripe_account_status = /** @type {(inputs: Stripe_Account_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status da Conta Stripe`)
};

const ko_stripe_account_status = /** @type {(inputs: Stripe_Account_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe 계정 상태`)
};

/**
* | output |
* | --- |
* | "Stripe Account Status" |
*
* @param {Stripe_Account_StatusInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const stripe_account_status = /** @type {((inputs?: Stripe_Account_StatusInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stripe_Account_StatusInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stripe_account_status(inputs)
	if (locale === "es") return es_stripe_account_status(inputs)
	if (locale === "fr") return fr_stripe_account_status(inputs)
	if (locale === "de") return de_stripe_account_status(inputs)
	if (locale === "ja") return ja_stripe_account_status(inputs)
	if (locale === "zh") return zh_stripe_account_status(inputs)
	if (locale === "ar") return ar_stripe_account_status(inputs)
	if (locale === "id") return id_stripe_account_status(inputs)
	if (locale === "it") return it_stripe_account_status(inputs)
	if (locale === "ru") return ru_stripe_account_status(inputs)
	if (locale === "pt") return pt_stripe_account_status(inputs)
	return ko_stripe_account_status(inputs)
});